import { makeStyles } from '@material-ui/core';

import palette from '../../theme/palette';

export default makeStyles(theme => ({
  root: {
    minHeight: '100vh',
    backgroundColor: palette.backgrounds.dark
  },
  container: {
    paddingTop: theme.spacing(10),
    paddingBottom: theme.spacing(4)
  },
  toolbar: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    padding: theme.spacing(1)
  },
  toolbarActions: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.5)
  },
  button: {
    width: theme.spacing(25),
    padding: theme.spacing(1),
    borderRadius: theme.spacing(6),
    color: palette.white,
    backgroundColor: palette.buttons.purple,
    fontWeight: 700,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: palette.primary.lighter
    },
    '&.Mui-disabled': {
      color: palette.white,
      backgroundColor: palette.common.grayAvatar
    }
  },
  count: {
    color: palette.white,
    fontWeight: 700
  },
  reviewBox: {
    minHeight: '75vh',
    width: '100%',
    borderRadius: theme.spacing(1.5),
    backgroundColor: palette.backgrounds.light
  },
  heading: {
    marginTop: theme.spacing(0.5),
    color: palette.white,
    fontSize: theme.spacing(3),
    fontWeight: 700
  },
  search: {
    marginTop: theme.spacing(0.5),
    borderRadius: theme.spacing(1.5),
    backgroundColor: palette.backgrounds.dark
  },
  searchInput: {
    color: `${palette.white} !important`,
    marginLeft: theme.spacing(1)
  },
  pdfContainer: {
    minHeight: '75vh',
    height: '100%',
    width: '100%',
    borderRadius: theme.spacing(1.5),
    backgroundColor: palette.backgrounds.light
  },
  notAvailable: {
    color: palette.white,
    fontSize: theme.spacing(3),
    fontWeight: 700
  },
  dialog: {
    backgroundColor: palette.white
  },
  confirm: {
    borderRadius: theme.spacing(6),
    color: palette.white,
    backgroundColor: palette.buttons.purple,
    fontWeight: 700,
    '&:hover': {
      backgroundColor: palette.primary.lighter
    }
  }
}));
